<template>
  <div>
    <div class="row">
      <div class="input-field col s12 m10 l6">
        <h3>Aktiválás</h3>
      </div>
    </div>

    <div class="col s12 offset-m1 m10 offset-l3 l6" v-if="nothingToActivate">
      Önnek nincs a rendszerben aktiválásra váró email címe vagy telefonszáma.
    </div>

    <div v-if="showEmail">
      <div class="header">
        <h5>Email</h5>
      </div>
      <div class="body">
        <form method="POST" autocomplete="on" id="form-user-update" action="/ajax/user/0">

          <div class="row">
            <div class="input-field col s12 offset-m1 m10 offset-l3 l6">
              <input type="text" required class="form-control" name="newEmail" id="newEmail" v-model="newEmail">
              <label for="newEmail" :class="[newEmail ? 'active' : '']">{{emailLabel}}</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12 offset-m1 m10 offset-l3 l6">
              <input required class="form-control" name="newEmailCode" id="newEmailCode" v-model="newEmailCode">
              <label for="newEmailCode" :class="[newEmailCode ? 'active' : '']">{{codeLabel}}</label>
            </div>
          </div>

          <div class="row">
            <div class="input-field col s12">
              <div class="right-align">
                <button v-on:click.prevent="activateEmail()"
                        class="btn waves-effect waves-light"
                        :class="[enableEmail ? '' : 'disabled']">
                  Email cím aktiválása
                  <i class="material-icons right">send</i>
                </button>
              </div>
            </div>
          </div>

        </form>
      </div>
    </div>

    <div v-if="showMobile">
      <div class="header">
        <h5>Telefonszám</h5>
      </div>
      <div class="body">
        <form method="POST" autocomplete="on" id="form-user-update" action="/ajax/user/0">

          <div class="row">
            <div class="input-field col s12 offset-m1 m10 offset-l3 l6">
              <input type="text" required class="form-control" name="newMobile" id="newMobile" v-model="newMobile">
              <label for="newMobile" :class="[newMobile ? 'active' : '']">{{mobileLabel}}</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12 offset-m1 m10 offset-l3 l6">
              <input required class="form-control" name="newMobileCode" id="newMobileCode" v-model="newMobileCode">
              <label for="newMobileCode" :class="[newMobileCode ? 'active' : '']">{{codeLabel}}</label>
            </div>
          </div>

          <div class="row">
            <div class="input-field col s12">
              <div class="right-align">
                <button v-on:click.prevent="activateMobile()"
                        class="btn waves-effect waves-light"
                        :class="[enableMobile ? '' : 'disabled']">
                  Telefonszám aktiválása
                  <i class="material-icons right">send</i>
                </button>
              </div>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import db from '../../db'
import {get} from '../../api'

export default {
  data() {
    return {
      newEmail: null,
      newEmailCode: null,
      newMobile: null,
      newMobileCode: null,
      showEmail: true,
      showMobile: true,
      emailLabel: 'Email',
      mobileLabel: 'Telefonszám',
      codeLabel: 'Megerősítő kód'
    }
  },
  ready() {
    this.init()
  },
  computed: {
    isLoggedIn: function() {
      return !_.isEmpty(db.get('user'))
    },
    enableEmail: function() {
      return (!_.isEmpty(this.newEmail) && !_.isEmpty(this.newEmailCode))
    },
    enableMobile: function() {
      return (!_.isEmpty(this.newMobile) && !_.isEmpty(this.newMobileCode))
    },
    nothingToActivate: function() {
      return this.isLoggedIn && (_.isEmpty(this.newMobile) && _.isEmpty(this.newEmail))
    }
  },
  methods: {
    init() {
      const userFromLocalStorage = db.get('user')
      // public
      if (_.isEmpty(userFromLocalStorage)) {
        this.newEmail = this.$route.query.email
        this.newMobile = this.$route.query.mobile

        return
      }

      // internal
      get(`/ajax/users/${userFromLocalStorage.uuid}`, (user) => {
        if (_.isEmpty(user.newEmail)) {
          this.showEmail = false
        } else {
          this.newEmail = user.newEmail
        }
        if (_.isEmpty(user.newMobile)) {
          this.showMobile = false
        } else {
          this.newMobile = user.newMobile
        }
      })
    },
    activateEmail() {
      if (this.enableEmail) {
        this.$router.go(`/activate/email/${this.newEmail}/${this.newEmailCode}`)
      }
    },
    activateMobile() {
      if (this.enableMobile) {
        this.$router.go(`/activate/sms/${this.newMobile}/${this.newMobileCode}`)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ActivationForm.vue?05b06360